<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useServiceStore } from '@stores/service'
import { Rive, Fit, Layout } from '@rive-app/canvas'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import gsap from 'gsap'
import ContactScroll from '@components/contact/ContactScroll.vue'

const contactSection = ref(null)

// Rive Animations
const crownCanvas = ref(null)
const scriptCanvas = ref(null)

onMounted(() => {
	gsap.registerPlugin(ScrollTrigger)

	const crownRive = new Rive({
		canvas: crownCanvas.value,
		src: 'https://cdn.papercrowns.com/website/rive/crown.riv',
		autoplay: true,
		autoBind: true,
		layout: new Layout({
			fit: Fit.Contain,
		}),
		stateMachines: 'crownsStateMachine',
		onLoad: () => {
			let vmi = crownRive.viewModelInstance
			const booleanProperty = vmi.boolean('isHovered')
			booleanProperty.value = true
		},
	})

	const scriptRive = new Rive({
		canvas: scriptCanvas.value,
		src: 'https://cdn.papercrowns.com/website/rive/script.riv',
		autoplay: true,
		autoBind: true,
		layout: new Layout({
			fit: Fit.Contain,
		}),
		stateMachines: 'crownsStateMachine',
		onLoad: () => {
			let vmi = scriptRive.viewModelInstance
			const booleanProperty = vmi.boolean('reveal')
			booleanProperty.value = false
		},
	})

	ScrollTrigger.create({
		trigger: contactSection.value,
		start: 'top center',
		end: 'bottom top',
		// markers: true,
		onEnter: () => {
			scriptRive.viewModelInstance.boolean('reveal').value = true
		},
		onLeave: () => {
			scriptRive.viewModelInstance.boolean('reveal').value = false
		},
		onEnterBack: () => {
			scriptRive.viewModelInstance.boolean('reveal').value = true
		},
		onLeaveBack: () => {
			scriptRive.viewModelInstance.boolean('reveal').value = false
		},
	})

	setTimeout(() => ScrollTrigger.refresh(), 5000)
})

onUnmounted(() => {
	ScrollTrigger.killAll()
})
</script>

<template>
	<section ref="contactSection" class="relative border-y border-crowns-grey" @click="ScrollTrigger.refresh()">
		<div class="container relative z-10 grid-cols-4 md:grid">
			<!-- Left Content -->
			<div class="col-span-1 hidden flex-col justify-center gap-10 py-10 md:flex xl:col-span-2">
				<!-- <p class="w-4/6">Jorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus.</p> -->
				<div class="flex items-center justify-center gap-5 md:flex-col md:gap-8 lg:gap-12">
					<canvas class="w-24 xl:w-32" height="512" width="512" ref="crownCanvas" />

					<h2 class="text-center">
						Let's Start
						<br />
						Your Project
					</h2>

					<canvas class="w-40 xl:w-48" height="450" width="512" ref="scriptCanvas" />
				</div>
				<!-- <p>Jorem ipsum dolor sit amet, consectetur adipiscing elit.</p> -->
			</div>

			<!-- Contact Form -->
			<div class="col-span-3 -mx-3 pt-10 md:py-20 md:pl-14 xl:col-span-2 xl:px-14 2xl:py-32">
				<ContactScroll />
			</div>
		</div>
		<div class="absolute left-0 top-0 z-0 h-full w-full grid-cols-2 md:grid">
			<div class="relative h-full w-full bg-crowns-off-black">
				<img class="absolute left-0 top-0 max-h-[26rem]" src="https://cdn.papercrowns.com/website/images/elements/textures/contact-top.png" alt="" />
				<img class="absolute bottom-0 right-0 max-h-[26rem]" src="https://cdn.papercrowns.com/website/images/elements/textures/contact-bottom.png" alt="" />
				<!-- <img class="absolute top-1/2 -mt-52 h-96 object-cover" src="https://cdn.papercrowns.com/website/images/elements/lockups/contact-us.svg" alt="Contact Us" /> -->
			</div>
			<div class="hidden h-full w-full bg-crowns-dark-grey md:block">
				<img class="absolute bottom-0 right-0 w-96" src="https://cdn.papercrowns.com/website/images/elements/etches/contact-composition.png" alt="Contact Us" />
			</div>
		</div>
	</section>
</template>
